import Popper from 'popper.js';
window.Popper = Popper;

document.addEventListener("DOMContentLoaded", function () {
    const promotions = document.querySelectorAll('.promotion');
    const categoryList = document.querySelectorAll('.category-list');

    const urlParams = new URLSearchParams(window.location.search);
    const displayPromoParam = urlParams.get('promo');

    promotions.forEach((promotion) => {
        const detailToggle = promotion.querySelector('.promotion__detail-toggle'),
            detailToggleText = detailToggle.textContent,
            detailToggleAltText = detailToggle.getAttribute('data-toggletext');

        detailToggle.removeEventListener('click', () => { });
        detailToggle.addEventListener('click', function (event) {
            event.preventDefault();
            promotion.classList.toggle('active');
            if (detailToggle.textContent === detailToggleText) {
                detailToggle.textContent = detailToggleAltText;
            } else {
                detailToggle.textContent = detailToggleText;
            }
        });

        if (displayPromoParam !== null) {
            detailToggle.click();
        }
    });

    const references = document.querySelectorAll('button.icr--active');

    references.forEach(function (reference) {

        reference.addEventListener('mouseover', () => { });
        reference.addEventListener('mouseover', function (event) {
            event.preventDefault();
            event.stopPropagation();

            references.forEach(function (promoButton) {
                let tooltip = promoButton.querySelector('.promotion--tooltip');
                if (tooltip !== null) {
                    tooltip.classList.remove('promotion--open');
                }
            });

            let tooltip = reference.querySelector('.promotion--tooltip');
            if (tooltip !== null) {
                tooltip.classList.add('promotion--open');
            }

            const popper = reference.querySelector('.promotion--tooltip');

            if (popper !== null) {
                const popperTooltip = new Popper(
                    reference,
                    popper,
                    {
                        // popper options here 
                        placement: 'auto',
                        modifiers: {
                            preventOverflow: {
                                enabled: true,
                                boundariesElements: categoryList
                            }
                        }
                    }
                );
            }
        });

        references.forEach(function (promoButton) {
            reference.addEventListener('mouseleave', () => { });
            reference.addEventListener('mouseleave', function (event) {
                let tooltip = promoButton.querySelector('.promotion--tooltip');
                if (tooltip !== null) {
                    tooltip.classList.remove('promotion--open');
                }
            });
        });

    });

    const tooltips = document.querySelectorAll('.promotion--tooltip');

    tooltips.forEach(function (tooltip) {
        tooltip.removeEventListener('click', () => { });
        tooltip.addEventListener('click', function (event) {
            event.stopPropagation();
        });
    });

    document.removeEventListener('click', () => { });
    document.addEventListener('click', function (event) {
        references.forEach(function (promoButton) {
            let tooltip = promoButton.querySelector('.promotion--tooltip');
            if (tooltip !== null) {
                tooltip.classList.remove('promotion--open');
            }
        });
    });
});